import React, { useEffect, useState, useRef } from "react";
import {
  Routes,
  Route,
  Navigate,
  NavLink,
  useLocation,
} from "react-router-dom";
import withRouter from "../../hooks/withRouter";
import StrategyDashboard from "./StrategyDashboard";
import "../../css/MenuSection/MenuSection.css";
import "../../css/CustomComponents/CustomChartComponents.css";
import "../../css/StrategyManagement/StrategyManagement.css";
import "../../css/BusinessNews/BusinessNews.css";
import SmallCase from "../Body/MenuSection/SmallCase";
import { GetCookie } from "../../exports/CookieManagement";
import { GetRoleType } from "../../exports/RoleTypes";
import useQueryParams from "../../hooks/useQueryParams";
import useStockInfo from "../../hooks/useStockInfo";
import { AddHistory, GetHistory } from "../../exports/HistoryStorage";
import { getDeviceSize } from "../../exports/InteractiveUtils";
import CustomerPortfolio from "./CustomerPortfolio";
import OrderPopup from "../Body/AppPopups/StockOrderPopup/OrderPopup";
import CustomerTransactions from "./CustomerTransactions";
import CustomerPosition from "./CustomerPosition";
import useAccount from "../../hooks/useAccount";
import MACPortfolio from "./MACPortfolio";
import CustomerPortfolioV2 from "./CustomerPortfolioV2";
import MACTransactions from "./MACTransactions";
import {
  ArrowDown2,
  ArrowUp2,
  BookMark,
  ICON_COLORS,
  OrderBook,
  Portfolio,
} from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import ConfirmationBook from "../TransactionManagement/ConfirmationBook";
import OrdersHistory from "../TransactionManagement/OrdersHistory";
import ManagedHoldings from "../TransactionManagement/ManagedHoldings";

const DEVICE_SIZE = getDeviceSize();

const ROUTE_NAME_MAP = {
  "/account/strategy": "Watchlist",
  "/account/strategy/stock": "Watchlist",
  "/account/strategy/portfolio": "Portfolio",
  "/account/strategy/transaction": "Transactions",
  "/account/strategy/position": "Net Position",
  "/account/strategy/manage": "Strategy Management",
  "/account/strategy/confirmation": "Order Confirmation",
  "/account/strategy/history": "Order History",
  "/account/strategy/holdings": "Mismatched Holdings",
};

function StrategyMenu({ account, user_role_type }) {
  const location = useLocation();
  const { pathname = "" } = location;
  const ref = useRef();

  const [menu, setMenu] = useState("Watchlist");
  const [menuPopup, setMenuPopup] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setMenuPopup(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setMenu(ROUTE_NAME_MAP[pathname]);
  }, [pathname]);

  function NavLinkCallback(menu_item) {
    setMenu(menu_item);
    setMenuPopup(false);
  }

  if (!account) return <></>;

  const { isAPI = false } = account;

  return (
    <>
      {/* <div
        className="swift-submenu-item"
        onClick={() => {
          setMenuPopup((prev) => !prev);
        }}
      >
        <p>{menu}</p>
        <span
          className={`${menuPopup ? "rotate-clockwise" : "rotate-anticlockwise"}`}
        >
          <ArrowDown2 size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
        </span>
      </div> */}
      <div ref={ref} className={"swift-submenu " + (menuPopup ? "active" : "")}>
        <NavLink
          to={`/account/strategy/stock`}
          onClick={() => {
            NavLinkCallback("Watchlist");
          }}
        >
          <p className={pathname === "/account/strategy/stock" ? "active" : ""}>
            {DEVICE_SIZE === "S" && (
              <BookMark
                color={
                  pathname === "/account/strategy/stock"
                    ? ICON_COLORS["SWIFT_COLOR1"]
                    : ICON_COLORS["SWIFT_COLOR4"]
                }
                size={25}
              ></BookMark>
            )}
            Watchlist
          </p>
        </NavLink>

        {user_role_type === "CUSTOMER" && (
          <>
            <NavLink
              to={`/account/strategy/portfolio`}
              onClick={() => {
                NavLinkCallback("Portfolio");
              }}
            >
              <p
                className={
                  pathname === "/account/strategy/portfolio" ? "active" : ""
                }
              >
                {DEVICE_SIZE === "S" && (
                  <Portfolio
                    color={
                      pathname === "/account/strategy/portfolio"
                        ? ICON_COLORS["SWIFT_COLOR1"]
                        : ICON_COLORS["SWIFT_COLOR4"]
                    }
                    size={25}
                  />
                )}
                Portfolio
              </p>
            </NavLink>
            <NavLink
              to={`/account/strategy/transaction`}
              onClick={() => {
                NavLinkCallback("Order Book");
              }}
              className="visible-desktop"
            >
              <p
                className={
                  pathname === "/account/strategy/transaction" ? "active" : ""
                }
              >
                Order Book
              </p>
            </NavLink>
            <NavLink
              to={`/account/strategy/confirmation`}
              onClick={() => {
                NavLinkCallback("Order Confirmation");
              }}
              className="visible-desktop"
            >
              <p
                className={
                  pathname === "/account/strategy/confirmation" ? "active" : ""
                }
              >
                Order Confirmation
              </p>
            </NavLink>
            <NavLink
              to={`/account/strategy/history`}
              onClick={() => {
                NavLinkCallback("Order History");
              }}
            >
              <p
                className={
                  pathname === "/account/strategy/history" ? "active" : ""
                }
              >
                {DEVICE_SIZE === "S" && (
                  <OrderBook
                    color={
                      pathname === "/account/strategy/history"
                        ? ICON_COLORS["SWIFT_COLOR1"]
                        : ICON_COLORS["SWIFT_COLOR4"]
                    }
                    size={25}
                  />
                )}
                Order History
              </p>
            </NavLink>
            <NavLink
              to={`/account/strategy/holdings`}
              onClick={() => {
                NavLinkCallback("Mismatched Holdings");
              }}
              className="visible-desktop"
            >
              <p
                className={
                  pathname === "/account/strategy/holdings" ? "active" : ""
                }
              >
                Mismatched Holdings
              </p>
            </NavLink>
          </>
        )}

        {user_role_type === "CUSTOMER" && isAPI && (
          <>
            <NavLink
              to={`/account/strategy/position`}
              onClick={() => {
                NavLinkCallback("Net Position");
              }}
            >
              <p
                className={
                  pathname === "/account/strategy/position" ? "active" : ""
                }
              >
                Net Position
              </p>
            </NavLink>
          </>
        )}
        {user_role_type === "BROKER" && (
          <>
            <NavLink
              to="/account/strategy/manage"
              onClick={() => {
                NavLinkCallback("Strategy Management");
              }}
            >
              <p
                className={
                  pathname === "/account/strategy/manage" ? "active" : ""
                }
              >
                Strategy Management
              </p>
            </NavLink>
          </>
        )}

        {/* <div
          className="swift-submenu-close"
          onClick={() => {
            setMenuPopup(false);
          }}
        >
          <Cross size={36} color={COLOR_VARS["SWIFT_COLOR4"]} />
        </div> */}
      </div>
    </>
  );
}

function StrategyManagement({ pannumber, clientid }) {
  const user_role_type = GetRoleType(GetCookie("role"));

  const { account } = useAccount();
  const [symbol, setSymbol] = useState(undefined);

  const [orderAction, setOrderAction] = useState(false);

  function OpenOrderPopup(action) {
    setOrderAction(action);
  }

  const { isAPI = false } = account;

  return (
    <div className="swift-strategy-management swift-content">
      {/* submenu */}
      <div className="swift-submenu-wrapper">
        <StrategyMenu account={account} user_role_type={user_role_type} />
      </div>
      <div className="strategy-content">
        <>
          <Routes>
            <Route
              path="stock"
              element={
                <StrategyDashboard
                  setSymbol={setSymbol}
                  OpenOrderPopup={OpenOrderPopup}
                />
              }
            />

            {/* <Route
              path="portfolio"
              element={isAPI ? <CustomerPortfolio /> : <MACPortfolio />}
            /> */}
            <Route
              path="portfolio"
              element={isAPI ? <CustomerPortfolio /> : <CustomerPortfolioV2 />}
            />

            <Route
              path="transaction"
              element={isAPI ? <CustomerTransactions /> : <MACTransactions />}
            />

            <Route path="confirmation" element={<ConfirmationBook />} />

            <Route path="history" element={<OrdersHistory />} />

            <Route path="holdings" element={<ManagedHoldings />} />

            <Route path="position" element={<CustomerPosition />} />

            <Route
              path="manage"
              element={<SmallCase pannumber={pannumber} clientid={clientid} />}
            />

            <Route
              path="*"
              element={<Navigate to="/account/strategy/stock" />}
            />
          </Routes>
        </>

        {orderAction && (
          <>
            <OrderPopup
              closeModal={() => {
                setOrderAction(false);
              }}
              config={{
                side: orderAction,
                symbol: symbol,
                squareoff: false,
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default withRouter(StrategyManagement);
